export default function CompanyResults() {
  const results = [
    { icon: 'ri-line-chart-line', title: 'Рост конверсии', desc: 'Конверсия звонков растёт на 15-25% после внедрения' },
    { icon: 'ri-calendar-check-line', title: 'Рост встреч', desc: 'Количество назначенных встреч увеличивается в 1,5-2 раза' },
    { icon: 'ri-money-dollar-circle-line', title: 'Рост продаж', desc: 'Рост выручки отдела за счёт увеличения потока квалифицированных лидов' },
    { icon: 'ri-funds-line', title: 'Рост среднего чека', desc: 'Менеджеры учатся продавать ценность, а не скидки' },
    { icon: 'ri-percent-line', title: 'Меньше скидок', desc: 'Клиенты реже просят скидку, когда ценность обоснована' },
    { icon: 'ri-search-eye-line', title: 'Лучшее выявление потребностей', desc: 'Менеджеры задают правильные вопросы до презентации' },
    { icon: 'ri-emotion-happy-line', title: 'Уверенность менеджеров', desc: 'Сотрудники перестают бояться звонков и отказов' },
    { icon: 'ri-file-list-3-line', title: 'Единый стандарт звонков', desc: 'Все менеджеры работают по единой эффективной структуре' },
    { icon: 'ri-user-add-line', title: 'Быстрая адаптация новичков', desc: 'Новые менеджеры выходят на результативность в 2 раза быстрее' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие результаты получает компания
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Измеримые бизнес-показатели, которые меняются после внедрения программы телефонных продаж.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {results.map((item, i) => (
            <div key={i} className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl p-5 md:p-6 text-white hover:shadow-lg transition-shadow group">
              <div className="w-12 h-12 bg-white/15 rounded-xl flex items-center justify-center flex-shrink-0 mb-4">
                <i className={`${item.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-white mb-2">{item.title}</h3>
              <p className="text-sm text-white/80 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}